module.exports = __webpack_public_path__ + "img/login-cover-image.b36060a2.jpg";